import { acceptOrderType, Business, CategoriesType, FloorType, ICurrencyRate, orderType, ProductType, productType, promotionDiscountType } from '@/config';
import { getToken } from '@/utils/helper';
import axios from 'axios';
import { getService } from './apiService';

const API_URL = `${import.meta.env.VITE_API_PRO}/api`;

const API_KEY = import.meta.env.VITE_API_KEY;

const token = getToken();

const service = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-api-key': API_KEY,
    },
});

export type FreeItem = {
    _id: string;
    quantity: number;
    name: string;
    image: string;
    tableName: string;
    price: number;
    instruction: string;
};



export function apiOrderAction(data: acceptOrderType) {
    return service.put(`waiters/action`, data);
}

async function apiGetFloors(businessId: string) {
    return await getService<FloorType[]>({
        url: `waiters/dashboards/floor-tables`, params: {
            isPagination: false,
            status: true,
            businessId,
            sort: 1
        }
    })
}

async function apiGetCategories(shopId: string) {
    return await getService<CategoriesType[]>({
        url: `categories`, params: {
            isPagination: false,
            status: true,
            businessId: shopId,
        }
    })
}

async function apiGetAllProduct(businessId: string) {
    return await getService<productType[]>({
        url: `products`, params: {
            isPagination: false,
            isDiscount: false,
            isSalable: true,
            status: true,
            businessId,
            type: ProductType.product,
        }
    })
}

async function apiGetProduct(businessId: string, searchKey: string, keyCategoryId?: string) {
    return await getService<productType[]>({
        url: `products`, params: {
            isPagination: false,
            status: true,
            isDiscount: false,
            isSalable: true,
            type: ProductType.product,
            businessId,
            searchKey,
            keyCategoryId
        }
    })
}

async function apiGetProductByID(productId: string) {
    return await getService<productType>({ url: `products/${productId}` })
}

async function apiGetOrder(tableId: string, params: any) {
    return await getService<orderType[]>({
        url: `waiters/orders/${tableId}`,
        // params: {
        //     productType: params.productType ? params.productType : null,
        // }
    })
}

async function getPromotionsDiscount(params?: any) {
    return await getService<promotionDiscountType[]>({
        url: `admin/promotion-discounts`, params: {
            businessId: params.businessId,
            isPagination: params.isPagination ? params.isPagination : false,
            status: params.status ? params.status : null,
            productStatus: true,
        }
    })
}

async function getPromotionsDiscountByID(id: string, productSearchKey: string) {
    return await getService<promotionDiscountType>({
        url: `admin/promotion-discounts/${id}`,
        params: {
            productSearchKey: productSearchKey,
            productStatus: true,
            optionStatus: true,
            productIsSalable: true,
        }
    })
}

async function getCurrencyRateService() {
    return await getService<ICurrencyRate>({ url: `admin/currency-rate` });
}

async function getBusinesseById(id: string) {
    return await getService<Business>({ url: `businesses/${id}` });
}

export function apiReturnItem(orderId: string, data: any) {
    return service.put(`admin/orders/${orderId}/return-or-delete-item-order`, data);
}

export { apiGetCategories, apiGetAllProduct, apiGetProductByID, apiGetOrder, apiGetProduct, getPromotionsDiscount, getPromotionsDiscountByID, apiGetFloors, getCurrencyRateService, getBusinesseById }